import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";
import { CoreLogService } from "../../services/log.service";

@Component({
  selector: "overlayspinner",
  templateUrl: "./overlaySpinner.component.html",
  styleUrls: ["./overlaySpinner.component.scss"]
})
export class OverlaySpinnerComponent implements OnInit {

  public showSpinner = true;

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService) {
    this._changeDetectorRef.detach();
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("OverlaySpinnerComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.PushChanges();
  }

}
